import { useState, useEffect } from 'react';
import { db, doc, onSnapshot } from '../firebase';

interface AppConfig {
  gtag?: string;
  showYahooMicrosoft: boolean;
  showEmailLoginLink: boolean;
  environment: string;
  stripePublishableKey: string;
  googlePayMerchantId: string;
  merchantName: string;
  price: string;
  currencyCode: string;
  countryCode: string;
  features: string[];
  expenseCategories: string[];
  defaultIncomeEntries: { note: string; category: string }[];
  graphColors: string[];
  currencies: { code: string; name: string; symbol: string }[];
  defaultExpenditureEntries: { note: string; category: string }[];
}

export function useAppSettings() {
  const [config, setConfig] = useState<AppConfig>({
    gtag: '',
    showYahooMicrosoft: false,
    showEmailLoginLink: false,
    environment: 'PRODUCTION',
    stripePublishableKey: '',
    googlePayMerchantId: '',
    merchantName: '',
    price: '',
    currencyCode: '',
    countryCode: '',
    features: [],
    expenseCategories: [],
    defaultIncomeEntries: [],
    graphColors: [],
    currencies: [],
    defaultExpenditureEntries: [],
  });

  useEffect(() => {
    const unsubscribe = onSnapshot(
      doc(db, 'app_settings', 'config'),
      (snapshot) => {
        if (snapshot.exists()) {
          setConfig((prev) => ({ ...prev, ...(snapshot.data() as AppConfig) }));
        }
      }
    );

    const unsubscribeConstants = onSnapshot(
      doc(db, 'app_settings', 'constants'),
      (snapshot) => {
        if (snapshot.exists()) {
          const data = snapshot.data();
          setConfig((prev) => ({
            ...prev,
            expenseCategories: data.categories || [],
            defaultIncomeEntries: data.default_income || [],
            graphColors: data.graph_colors || [],
            currencies: data.currencies || [],
            defaultExpenditureEntries: data.default_expenditure || [],
          }));
        }
      }
    );

    return () => {
      unsubscribe();
      unsubscribeConstants();
    };
  }, []);

  return config;
}
